import { DropdownItem } from '../models';

export const simulatorNavDropdownActions = {
  // patient_settings
  open_patient_settings: 'open-patient-settings',
  // 3D viewer
  open_3D_viewer: 'open-3D-viewer',
  // image viewer
  open_image_viewer: 'open-image-viewer',
  // scanner_settings
  open_scanner_settings: 'open-scanner-settings',
  // advanced
  open_tissues_characteristics: 'open-tissues-characteristics',
  // simulation_settings
  open_simulation_settings: 'open-simulation-settings',
  // isotropic
  set_isotropic_0: 'set_isotropic_0',
  set_isotropic_1: 'set_isotropic_1',
  set_isotropic_05: 'set_isotropic_05',
  set_isotropic_optimal: 'set_isotropic_optimal',
  // motion
  set_motion_options: 'set_motion_options',
  // isocenter
  open_iso_center_modal_whole_body: 'open-iso-center-modal-whole-body',
  open_iso_center_modal_regions: 'open-iso-center-modal-regions',
  // notification
  open_notification_view: 'open-notification-view',
  // help
  open_help_view: 'open-help-view',
  // default cardiac phase
  set_default_cardiac_phase: 'set_default_cardiac_phase',
  // default vs custom simulation configuration
  set_configuration_0: 'set_configuration_0',
  set_configuration_1: 'set_configuration_1',
  // breathing mode
  set_breathold_exhale: 'breathhold_full_exhale',
  set_breathold_inhale: 'breathhold_full_inhale',
  set_breathold_free: 'free_breathing',
};

export const imageViewerDropdownItems: DropdownItem[] = [
  {
    action: simulatorNavDropdownActions.open_image_viewer,
  },
];

export const advancedDropdownItems: DropdownItem[] = [
  {
    action: simulatorNavDropdownActions.open_tissues_characteristics,
  },
];

export const isotropicDropdownItems: DropdownItem[] = [
  {
    action: simulatorNavDropdownActions.set_isotropic_0,
  },
  {
    action: simulatorNavDropdownActions.set_isotropic_1,
  },
  {
    action: simulatorNavDropdownActions.set_isotropic_05,
  },
  {
    action: simulatorNavDropdownActions.set_isotropic_optimal,
  },
];

export const motionDropdownItems: DropdownItem[] = [
  {
    action: simulatorNavDropdownActions.set_motion_options,
  },
];

export const defaultCardiacPhaseDropdownItems: DropdownItem[] = [
  {
    action: simulatorNavDropdownActions.set_default_cardiac_phase,
  },
];

export const isocenterDropdownItems: DropdownItem[] = [
  {
    action: simulatorNavDropdownActions.open_iso_center_modal_whole_body,
  },
  {
    action: simulatorNavDropdownActions.open_iso_center_modal_regions,
  },
];

export const notificationDropdownItems: DropdownItem[] = [
  {
    action: simulatorNavDropdownActions.open_notification_view,
  },
];

export const helpDropdownItems: DropdownItem[] = [
  {
    action: simulatorNavDropdownActions.open_help_view,
  },
];

export const scannerSettingsDropdownItems: DropdownItem[] = [
  {
    action: simulatorNavDropdownActions.open_scanner_settings,
  },
];

export const simulationSettingsDropdownItems: DropdownItem[] = [
  {
    action: simulatorNavDropdownActions.open_simulation_settings,
  },
];

export const patientSettingsDropdownItems: DropdownItem[] = [
  {
    action: simulatorNavDropdownActions.open_patient_settings,
  },
];

const constants = {
  imageViewerDropdownItems,
  patientSettingsDropdownItems,
  scannerSettingsDropdownItems,
  simulationSettingsDropdownItems,
  advancedDropdownItems,
  isotropicDropdownItems,
  isocenterDropdownItems,
  motionDropdownItems,
  notificationDropdownItems,
  helpDropdownItems,
  simulatorNavDropdownActions,
  defaultCardiacPhaseDropdownItems,
};

export default constants;
